import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import './UpdateContactAndAccountDetails.scss';
import PopUp from '../../Shared/Popup/PopUp';
import { PopUpTypeEnum, ProgressTypeEnum } from '../PopupBenefitBlock/PopUpBenefitEnum';
import PopUpAlreadyUsedBenefit from '../PopupBenefitBlock/PopupAlreadyUsedBenefit';
import PopUpOutOfStockBenefit from '../PopupBenefitBlock/PopupOutOfStockBenefit';
import ThirdParty from '../../Shared/ThirdParty/ThirdParty';
import { buildUrlAndOpenWindow, prepareNewWindowUrl } from '../../../utilities/StringHelpers/StringHelpers';
import { updateContactAndAccountDetails, getContactAndAccountDetails, validateHandler, changeHandler, getCities, getStreets, setHomeNum, setIsNotFoundError, initValidation, clearAddress, resetBlock, setIsFromBack, setIsReported, setIsReadyForReport, setIsBenefitForm, reportAnalytics, clearAddressDetails, addressReportStep, setIsValid, handleCheckBox, reportCheckboxAgreeTermsCheckedWithBenefit, reportCheckboxAgreeTermsCheckedWithoutBenefit, reportPageLoadedWithBenefit, reportPageLoadedWithoutBenefit, reportWithBenefitSubmit, reportSuccess, reportFailed, reportWithoutBenefitSubmit, reportFailedBenefitIssue, setProgressType } from './UpdateContactAndAccountDetailsSlice';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import { Row, Col } from 'reactstrap';
import CheckBox from '../../Shared/CheckBox/Checkbox';
import TextInput from '../../Shared/TextInput/TextInput';
import Autocomplete from '../../Shared/AutoCompleteInput/AutoCompleteInput.js';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import SelectInput from '../../Shared/SelectInput/SelectInput';
import { updateUserDetails } from '../../../utilities/authentication/authenticationSlice';
import { getReportParams, report } from '../../../middleware/report';
import { setIsShowPopup, reportPopUpShow, reportPopUpAction, setIsPrepared, setPopUpType, setProgressType as setProgressTypeBenefit, resetBlock as resetBlockBenefit } from '../PopupBenefitBlock/BenefitSlice';
import { dwhThirdPartyConsentCheckboxDisplay } from '../ChangePricePlanBlock/reports/dwhReports';
import Config from '../../../Config';
import Image from "../../Shared/Image/image";
import updateDetails from './images/update_details.svg';
import phoneIcon from './images/group-12@2x.svg';
import errorIcon from './images/update_contact_and_account_details_icon_error.svg';
import successIcon from './images/update_contact_and_account_details_icon_ok.svg';
const UpdateContactAndAccountDetailsMain = props => {
  let cityDefaultVal = '';
  let streetDefaultVal = '';
  const [isValidForm, setIsValidForm] = useState(false);
  const [homeDefaultValue, setHomeDefaultValue] = useState('');
  const [cityDefault, setCityDefault] = useState('');
  const [streetDefault, setStreetDefault] = useState('');
  const [parentValue, setParentValue] = useState('');
  const cityRef = useRef();
  const streetRef = useRef();
  const homeRef = useRef();
  const formErrorRef = useRef();
  const formSuccessRef = useRef();
  let blockId = props.iContent.contentLink.id;
  const submitBottonOnPopupContactDetailsReport = {
    customerName: props.customerName,
    contactId: props.contactId,
    param1: props.iContent.offerBenefit?.value ? 'IS BENEFIT PROCESS' : "ISN'T BENEFIT PROCESS"
  };

  const PopUpComponent = () => {
    closeOrOpenPopupReportDWH('open');

    switch (props.popUpType) {
      case PopUpTypeEnum.AlreadyUsedBenefit:
        return <>
            <PopUpAlreadyUsedBenefit onNavigate={onNavigate} onClose={onClose} param2={"CUSTOMER ISN'T BENEFIT ELIGIBLE"} dwhDetails={submitBottonOnPopupContactDetailsReport} benefitButtonText={'לעדכון פרטים'} benefitSecondButtonText={'בפעם אחרת'}>
              <h1 className='benefitSubject'>לקוח יקר!</h1>
              <span className='benefitSecondHeader'>שמנו לב שכבר קיבלת את ההטבה כמובן שגם ללא הטבה באפשרותך לעדכן פרטים</span>
            </PopUpAlreadyUsedBenefit>
          </>;

      case PopUpTypeEnum.OutOfStockBenefit:
        return <>
            <PopUpOutOfStockBenefit onNavigate={onNavigate} dwhDetails={submitBottonOnPopupContactDetailsReport} onClose={onClose} param2={'CUSTOMER IS BENEFIT ELIGIBLE'} benefitButtonText={'לעדכון פרטים'} benefitSecondButtonText={'בפעם אחרת'}>
              <h1 className='benefitSubject'>לקוח יקר!</h1>
              <span className='benefitSecondHeader'>
                באופן זמני לא ניתן לקבל את ההטבה, אנחנו עובדים על חידוש מלאי ההטבות כמובן שגם ללא הטבה באפשרותך לעדכן פרטים
              </span>
            </PopUpOutOfStockBenefit>
          </>;

      default:
        return <></>;
    }
  };

  const onClose = actionType => {
    closeOrOpenPopupReportDWH('close');

    try {
      props.setIsShowPopup(false);

      if (actionType != undefined && actionType != null && typeof actionType === 'string' && actionType != '') {
        props.reportPopUpAction(actionType);
      }

      setTimeout(() => {
        props.resetBlockBenefit();
      }, 500);
    } catch (e) {
      console.log(e);
    }
  };

  const onNavigate = e => {
    onClose(e);
  };

  function generatePopUpReport() {
    let reportParams = getReportParams();
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'Personal Info Update';
    reportParams.channel = 'WebsitePrivate';
    reportParams.status = 'Ongoing';
    reportParams.customerName = props.customerName;
    reportParams.subscriber = '';
    reportParams.idNumber = props.contactId;
    reportParams.param1 = props.iContent.offerBenefit?.value ? 'IS BENEFIT PROCESS' : "ISN'T BENEFIT PROCESS";
    reportParams.param3 = '';
    reportParams.actionType = 'Display PopUp to Update Info';
    reportParams.messageText = 'Display PopUp to Update Info';

    switch (props.popUpType) {
      case PopUpTypeEnum.AlreadyUsedBenefit:
        reportParams.actionType = 'Display PopUp Benefit not eligible';
        reportParams.messageText = 'Display PopUp Benefit not eligible';
        reportParams.param2 = "CUSTOMER ISN'T BENEFIT ELIGIBLE";
        reportParams.param4 = "BENEFIT ISN'T AVAILABLE";
        break;

      case PopUpTypeEnum.OutOfStockBenefit:
        reportParams.actionType = 'Display PopUp Benefit not available';
        reportParams.messageText = 'Display PopUp Benefit not available';
        reportParams.param2 = 'CUSTOMER IS BENEFIT ELIGIBLE';
        reportParams.param4 = "BENEFIT ISN'T AVAILABLE";
        break;
    }

    report(reportParams);
  } //DWH => report on close popup without update contact details


  function closeOrOpenPopupReportDWH(type) {
    let reportParams = getReportParams();
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'Personal Info Update';
    reportParams.channel = 'WebsitePrivate';
    reportParams.status = 'Ongoing';
    reportParams.customerName = props.customerName;
    reportParams.subscriber = '';
    reportParams.idNumber = props.contactId;
    reportParams.param1 = props.iContent.offerBenefit?.value ? 'IS BENEFIT PROCCESS' : "ISN'T BENEFIT PROCESS";
    reportParams.actionType = 'Clicked Close PopUp Without Update';
    reportParams.messageText = 'Clicked Close PopUp Without Update';
    let isEligible = 'CUSTOMER IS BENEFIT ELIGIBLE';

    if (props.popUpType == PopUpTypeEnum.AlreadyUsedBenefit) {
      isEligible = "CUSTOMER ISN'T BENEFIT ELIGIBLE";
    }

    reportParams.param2 = isEligible;
    reportParams.param3 = '';
    reportParams.param4 = "BENEFIT ISN'T AVAILABLE";

    if (type == 'open') {
      reportParams.actionType = 'Display PopUp to Update Info';
      reportParams.messageText = 'Display PopUp to Update Info';
    }

    report(reportParams);
  } //DWH Report PopUpReport


  useEffect(() => {
    if (props.isPrepared) {
      try {
        generatePopUpReport();
        props.reportPopUpShow();
      } catch (e) {
        console.log(e);
      }
    }
  }, [props.isPrepared]); //DWH Report UpdateContactAndAccountDetails

  useEffect(() => {
    try {
      if (props.form.report.isReadyForReport && props.form.report.isReported == false) {
        let reportParams = getReportParams();
        reportParams.area = 'SelfCare';
        reportParams.subArea = 'Personal Info Update';
        reportParams.channel = 'WebsitePrivate';
        reportParams.customerName = props.customerName;
        reportParams.actionType = 'Entered Update Page';
        reportParams.status = 'Ongoing';
        reportParams.messageText = 'Entered Update Page';
        reportParams.subscriber = '';
        reportParams.idNumber = props.contactId;
        reportParams.param1 = props.iContent.offerBenefit?.value ? 'IS BENEFIT PROCCESS' : "ISN'T BENEFIT PROCESS";
        reportParams.param2 = props.iContent.offerBenefit.value && props.contactDetails.benefit.offerBenefit ? 'CUSTOMER IS BENEFIT ELIGIBLE' : "CUSTOMER ISN'T BENEFIT ELIGIBLE";
        reportParams.param3 = props.contactDetails?.collaborationApproval == 'false' && props.iContent.collaborationApproval?.value ? 'SHATAP DISPLAYED' : 'SHATAP NOT DISPLAYED';
        report(reportParams);

        if (props.contactDetails?.collaborationApproval == 'false' && props.iContent.collaborationApproval?.value) {
          dwhThirdPartyConsentCheckboxDisplay(props.customerName, props.contactDetails.phone, props.contactId, 'עדכון פרטים אישיים');
        } //gA


        if (props.form.isBenefitForm) {
          props.reportPageLoadedWithBenefit();
        } else {
          props.reportPageLoadedWithoutBenefit();
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsReported(true);
    }
  }, [props.form.report.isReadyForReport]); //IsBenefitForm ?

  useEffect(() => {
    if (props.form.isReady) {
      if (props.iContent.offerBenefit.value != null && props.contactDetails.benefit != null) {
        var isBenefitForm = props.iContent.offerBenefit.value && props.contactDetails.benefit.offerBenefit ? true : false;
        props.setIsBenefitForm(isBenefitForm);
        props.setIsReadyForReport(true);

        if (props.iContent.entranceFromSMS?.value) {
          let isReadyForPopUp = false;
          props.setProgressType(ProgressTypeEnum.SMS);
          props.setProgressTypeBenefit(ProgressTypeEnum.SMS);

          if (props.contactDetails.benefit.alreadyUsedBenefit) {
            props.setPopUpType(PopUpTypeEnum.AlreadyUsedBenefit);
            isReadyForPopUp = true;
          } else if (props.contactDetails.benefit.isBenefitOutOfStock) {
            props.setPopUpType(PopUpTypeEnum.OutOfStockBenefit);
            isReadyForPopUp = true;
          }

          if (isReadyForPopUp) {
            props.setIsPrepared(true);
            props.setIsShowPopup(true);
          }
        }
      }
    }
  }, [props.form.isReady]);
  useExtendedEffect(runSideEffects => {
    if (runSideEffects()) {
      if (props.form.isSuccessForm == true) {
        try {
          setTimeout(() => {
            setFocus('formSuccessRef');
            let payload = props.form.report.progressType + ' ' + props.form.isBenefitForm ? 'הטבה' : 'לא הטבה';
            props.reportSuccess(payload);
          }, 300);
        } catch (e) {
          console.log(e);
        }
      }
    }
  }, [props.form.isSuccessForm]);
  useExtendedEffect(runSideEffects => {
    if (runSideEffects()) {
      if (props.form.isFailedForm == true) {
        try {
          setTimeout(() => {
            setFocus('formErrorRef');
            let payload = props.form.report.progressType + ' ' + props.form.isBenefitForm ? 'הטבה' : 'לא הטבה';

            if (props.form.isBenefitForm) {
              props.reportFailedBenefitIssue(payload);
            } else {
              props.reportFailed(payload);
            }
          }, 300);
        } catch (e) {
          console.error(e);
        }
      }
    }
  }, [props.form.isFailedForm]);
  useExtendedEffect(runSideEffects => {
    if (runSideEffects()) {
      if (props.onSubmit && props.onSubmit == true) {
        props.initValidation();
        props.validateHandler(props.form);
      }
    }
  }, [props.onSubmit]);
  useExtendedEffect(runSideEffects => {
    if (runSideEffects()) {
      if (props.form.valid !== '') {
        handleValidateChange();
      }
    }
  }, [props.form.valid]);

  const handleClick = () => {
    props.initValidation();
    props.validateHandler(props.form);
  };

  useExtendedEffect(runSideEffects => {
    if (runSideEffects()) {
      if (props.form.errorObj != '') {// props.onError(props.form.errorObj.errorId);
      }
    }
  }, [props.form.errorObj]);
  useExtendedEffect(runSideEffects => {
    if (runSideEffects()) {
      if (isValidForm == true) {
        var request_updateContactDetails = {
          addressData: props.form.addressData,
          firstName: props.form.firstName,
          lastName: props.form.lastName,
          primaryEmail: props.form.email,
          isChangedAgreeNews: props.form.isChangedAgreeNews,
          collaborationApproval: props.form.isAgreeNews,
          blockId: blockId,
          accounts: [{
            street: props.form.streetName,
            city: props.form.cityName,
            apartment: props.form.apartment,
            houseNo: props.form.home,
            entrance: props.form.isSelectedEntrance ? props.form.entrance : ''
          }]
        };
        props.updateContactAndAccountDetails(request_updateContactDetails);
        props.showAppLoader();
      }
    }
  }, [isValidForm]);
  useEffect(() => {
    async function getContactAndAccountDetails(blockId) {
      props.showAppLoader();
      await props.getContactAndAccountDetails(blockId);
    }

    getContactAndAccountDetails(blockId);
  }, []);
  useExtendedEffect(runSideEffects => {
    props.getCities();

    if (props.form.cities.length > 0 && props.form.home != '') {
      setCityDefault(props.form.cityName);
      props.setIsFromBack(); // props.hideAppLoader();
    }

    if (props.form.cities.length > 0 && props.form.home != '') {
      setStreetDefault(props.form.streetName);
    }

    if (props.form.isCityWithoutStreets == true) setHomeDefaultValue('0');
    props.initValidation();
    return () => {
      if (runSideEffects()) {//  props.hideAppLoader();
      }
    };
  }, []);
  useExtendedEffect(runSideEffects => {
    if (runSideEffects()) {
      if (props.form.city != '' && props.form.city != ' ' && props.form.city != undefined) {
        props.clearAddressDetails();
        setParentValue(props.form.city);
        props.getStreets(props.form.city);
      }
    }
  }, [props.form.city]);
  useExtendedEffect(runSideEffects => {
    if (runSideEffects()) {
      if (props.form.cityName != '') setFocus('street');
    }
  }, [props.form.cityName]);
  useExtendedEffect(runSideEffects => {
    if (runSideEffects()) {
      if (props.form.streetName != '') setFocus('home');
      if (props.form.isCityWithoutStreets == true) setHomeDefaultValue('0');else setHomeDefaultValue('');
    }
  }, [props.form.streetName]); //Hide Loader

  useExtendedEffect(runSideEffects => {
    if (runSideEffects()) {
      if (props.form.isReady || props.form.isFailedForm || props.form.isSuccessForm) {
        props.hideAppLoader();
      }
    }
  }, [props.form.isReady, props.form.isFailedForm, props.form.isSuccessForm]);

  const keyUpHandler = () => {
    if (props.onHomeChange) {
      if (props.form.home != '') props.onHomeChange(true);
    }
  };

  const openPhoneDialer = num => {
    document.location.href = 'tel:' + num;
  };

  const handleValidateChange = () => {
    let isValid = props.form.valid;

    if (isValid) {
      setIsValidForm(true);

      if (props.form.isBenefitForm) {
        props.reportWithBenefitSubmit('הצלחה');
      } else {
        props.reportWithoutBenefitSubmit('הצלחה');
      }
    } else {
      setIsValidForm(false);

      if (props.form.isBenefitForm) {
        props.reportWithBenefitSubmit('שגיאה');
      } else {
        props.reportWithoutBenefitSubmit('שגיאה');
      }
    }
  };

  const navigateToPolicy = async link => {
    prepareNewWindowUrl(link, props.context);
  };

  function resultsNotFound(obj) {
    props.setIsNotFoundError({
      isNotFoundError: obj.value
    });
  }

  function Navigate() {
    props.resetBlock();
    props.context.navigateTo(props.iContent.progressLink.value);
  }

  const scrollInto = inputName => {
    const input = document.querySelector('input[name=' + inputName + ']');

    if (input !== null && window.innerHeight <= 350) {
      input.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const setFocus = name => {
    switch (name) {
      case 'city':
        if (cityRef.current) cityRef.current.autoCompleteRef.current.focus();
        break;

      case 'street':
        if (streetRef.current) streetRef.current.autoCompleteRef.current.focus();
        break;

      case 'home':
        if (homeRef.current) homeRef.current.focus();
        break;

      case 'formErrorRef':
        if (formErrorRef.current) formErrorRef.current.focus();
        break;

      case 'formSuccessRef':
        if (formSuccessRef.current) formSuccessRef.current.focus();
        break;
    }
  };

  return <div className='updateContactAndAccountDetailsMainForm'>
      {props.isPrepared ? <div className='popUpContainer'>
          <PopUp onClose={onClose} preventWrapperClose={true} showPopUp={props.isShowPopUp}>
            <PopUpComponent />
          </PopUp>
        </div> : ''}

      {props.form.isReady ? <form className=''>
          <div className='icon' style={{backgroundImage:updateDetails.bg()}}>
      </div>
          <p className='fullName'>
            {props.contactDetails.firstName} {props.contactDetails.lastName}
          </p>
          <p className='contactId'>
            <span style={{
          marginLeft: '5px'
        }}>ת.ז</span>
            <span>{props.contactId}</span>
          </p>
          <p className='headerText'>{props.iContent.titleText.value}</p>
          {props.iContent.offerBenefit.value && props.contactDetails.benefit.offerBenefit ? <div>
              <div className='benefitContainer'>
                <div className='benefitText' dangerouslySetInnerHTML={{
            __html: props.iContent.textBenefit.value
          }}></div>
                <p className='benefitPolicy' onClick={() => navigateToPolicy(props.iContent.benefitPolicyLink.value)}>
                  לתקנון ההטבה
                </p>
              </div>
            </div> : ''}
          <p className='formHeader'>כל השדות המסומנים בכוכבית הינם שדות חובה</p>
          <div className='formContainer'>
            <p className='formHeaderText'>שם פרטי ושם משפחה</p>
            <p className='addressHeaderText'>עבור ת.ז {props.contactId}</p>
            <TextInput placeholder='שם פרטי' name='firstName' value={props.form.firstName} onChange={e => props.changeHandler({
          target: e.target,
          form: props.form
        })} required='required' error={props.form.errors?.firstName} // error={showNewMailError}
        />
            <TextInput placeholder='שם משפחה' name='lastName' value={props.form.lastName} onChange={e => props.changeHandler({
          target: e.target,
          form: props.form
        })} required='required' error={props.form.errors?.lastName} // error={showNewMailError}
        />
            <p className='emailBottomText'>בעדכון שם לקוח הנכם מאשרים כי השם תואם למספר תעודת הזהות</p>
          </div>
          <div className='formContainer'>
            <p className='formHeaderText'>כתובת מגורים</p>
            <p className='addressHeaderText'>לכתובת זו נשלח גם את חשבוניות {window.Config.brand_Name_HE} שנשלחות בדואר</p>
            <input type='hidden' name='hdnCity' />
            <div onClick={() => scrollInto('city')} name='cityContainer'>
              <Autocomplete ref={cityRef} defaultValue={cityDefaultVal} injectedValue={cityDefault} error={props.form.errors.city} value={props.form.city} resultsNotFound={resultsNotFound} id='city' name='city' onSelectedChange={props.changeHandler} form={props.form} suggestions={props.cities} dataKey='cityCode' dataValue='cityName' placeholder='עיר' required='required' />
            </div>
            {!props.form.isCityWithoutStreets ? <Autocomplete ref={streetRef} defaultValue={streetDefaultVal} injectedValue={streetDefault} updateValue={parentValue} error={props.form.errors.street} value={props.form.street} id='street' name='street' disabled={props.form.isSelectedCity ? '' : 'disabled'} onSelectedChange={props.changeHandler} form={props.form} suggestions={props.form.streets} dataKey='streetCode' dataValue='streetName' placeholder='רחוב' required='required' /> : <TextInput error={props.form.errors.apartment} placeholder='רחוב' id='dummyStreet' name='dummyStreet' type='text' disabled maxLength='10' autoComplete='off' value={props.form.streetName} required='required' />}

            <div className='formContainerGroupInput'>
              <TextInput ref={homeRef} className='groupInput' error={props.form.errors.home} placeholder='בית' id='home' name='home' maxLength='10' disabled={props.form.isSelectedStreet ? '' : 'disabled'} type='number' pattern='[0-9]*' autoComplete='off' value={!props.form.isCityWithoutStreets && props.form.home != undefined ? props.form.home : homeDefaultValue} onKeyUp={keyUpHandler} onChange={e => props.changeHandler({
            target: e.target,
            form: props.form
          })} required='required' />
              <TextInput error={props.form.errors.apartment} className='groupInput' placeholder='דירה' id='apartment' disabled={props.form.isSelectedStreet ? '' : 'disabled'} name='apartment' type='number' pattern='[0-9]*' maxLength='10' autoComplete='off' value={props.form.apartment != undefined ? props.form.apartment : ''} onChange={e => props.changeHandler({
            target: e.target,
            form: props.form
          })} required={props.form.isApartmentRequired ? 'required' : undefined} />

              <SelectInput className='groupInput' error={props.form.errors.entrance} disabled={props.form.isSelectedStreet ? '' : 'disabled'} options={props.form.entranceOptions} dataValue='value' id='input-entrance' name='entrance' // required={props.form.isEntranceRequired ? 'required' : undefined}
          // defaultText={'בחר'}
          placeholder={'כניסה'} value={props.form.entrance} onChange={e => props.changeHandler({
            target: e.target,
            form: props.form
          })} />
            </div>
          </div>

          <div className='formContainer'>
            <p className='formHeaderText email'>{Config.receivingAdTitle}</p>
            <TextInput error={props.form.errors.email} placeholder='כתובת מייל' id='email' name='email' required={props.form.isEmailRequired ? 'required' : undefined} value={props.form.email != undefined ? props.form.email : ''} onChange={e => props.changeHandler({
          target: e.target,
          form: props.form
        })} />

            <div className='emailBottomText'>
              {Config.primaryEmailText}{' '}
              <a href='#' className='link' onClick={() => buildUrlAndOpenWindow(Config.primaryEmailMoreInfoUrl)}>
                {Config.primaryEmailMoreInfoText}
              </a>{' '}
            </div>
          </div>

          <div className='formContainer' style={{
        background: 'unset'
      }}>
            <Row className='termOfService'>
              <Col xs='2' md='1' className='termOfService__checkbox'>
                <div>
                  <CheckBox id='isAgreeDetails' name='isAgreeDetails' label={'אני מאשר את נכונות הפרטים שמסרתי'} onCheck={e => {
                props.handleCheckBox({
                  name: e,
                  value: true
                });

                if (props.form.isBenefitForm) {
                  props.reportCheckboxAgreeTermsCheckedWithBenefit();
                } else {
                  props.reportCheckboxAgreeTermsCheckedWithoutBenefit();
                }
              }} onUncheck={e => props.handleCheckBox({
                name: e,
                value: false
              })} required={props.isAgreeDetailsRequired ? 'required' : undefined} checked={props.checked} children={<span className='pinkStar'>*</span>} error={props.form.errors?.isAgreeDetails}></CheckBox>
                </div>
              </Col>
            </Row>

            {props.contactDetails?.collaborationApproval == 'false' && props.iContent.collaborationApproval?.value ? <Row className='termOfService'>
                <Col xs='2' md='1' className='termOfService__checkbox'>
                  <div>
                    <CheckBox id='isAgreeNews' name='isAgreeNews' onCheck={e => props.handleCheckBox({
                name: e,
                value: true
              })} onUncheck={e => props.handleCheckBox({
                name: e,
                value: false
              })} //label={props.iContent.collaborationText?.value}
              label={<ThirdParty />} // label={<> אני מאשר/ת קבלת דברי פרסומת מסלקום ושותפיה העסקיים, ושיתוף מידע כמפורט להלן (גם אם לא תסמן, נשלח פרסומות לשירותינו בלבד, אלא אם ביקשת הסרה) <a href='#' onClick={() => buildUrlAndOpenWindow(Config.advertisingInfoLink)}>המשך</a> </>}
              ></CheckBox>
                  </div>
                </Col>
              </Row> : ''}
            <Row className=''>
              <button type='button' className='btn-submit btnUpdateContactDetails' onClick={() => {
            handleClick();
          }}>
                <span className='benefitButtonText'>אוקיי, עדכנו את הפרטים</span>
              </button>
            </Row>
          </div>
        </form> : ''}
      {props.form.isSuccessForm ? <>
          <form className='updateContactAndAccountDetailsSecondaryForm' ref={formSuccessRef} id='formSuccess'>
            <h1 className='successFormHeader'>תודה, הפרטים עודכנו בהצלחה!</h1>
            <div className='iconSuccessForm' style={{backgroundImage:successIcon.bg()}}>
        </div>
            {props.iContent.offerBenefit.value && props.contactDetails.benefit.offerBenefit ? <p className='subMessageSuccessForm'>שלחנו את ההטבה לכתובת המייל שהגדרת</p> : <p className='subMessageSuccessForm'></p>}

            <p className='infoMessageForm'>השינויים יכנסו לתוקף בעוד מספר דקות</p>
            <button type='button' className='btn-submit btnUpdateContactDetails' onClick={() => {
          Navigate();
        }}>
              <span className='benefitButtonText'>סיום</span>
            </button>
          </form>
        </> : ''}

      {props.form.isFailedForm ? <>
          <form className='updateContactAndAccountDetailsSecondaryForm' ref={formErrorRef} id='formError'>
            <h1 className='errorFormHeader'>
              רק רגע,
              <br />
              משהו השתבש…
            </h1>
            <p className='subMessageFailedForm'>{props.form.failedForm.subMessageFailedForm}</p>
            <div className='iconErrorForm' style={{backgroundImage:errorIcon.bg()}}>
        </div>
            <p className='subMessageFailedForm'>
              {props.form.failedForm.isBenefitIssue ? <>
                  באפשרותך <br />
                  לפנות לשירות לקוחות בשעות הפעילות
                </> : <>
                  בעוד מספר דקות <span className='subMessagePinkForm'>לנסות שוב</span> באפשרותך או לפנות לשירות לקוחות בשעות הפעילות
                </>}
            </p>
            <button type='button' className='btn-submit btnUpdateContactDetails' onClick={() => {
          Navigate();
        }}>  
              <span className='benefitButtonText'>סיום</span>
            </button>
            <div className='iconWhiteButton' style={{backgroundImage:phoneIcon.bg()}} onClick={() => openPhoneDialer(window.Config.technicalSupportPhone)}>
        </div>

            <button type='button' className='btn-submit btnUpdateContactDetails' onClick={() => {
          Navigate();
        }}>
              <span className='benefitButtonText'>סיום</span>
            </button>
          </form>
        </> : ''}
    </div>;
};

const mapStateToProps = state => ({
  form: state.updateContactAndAccountDetails.form,
  contactDetails: state.updateContactAndAccountDetails.contactDetails,
  cities: state.updateContactAndAccountDetails.cities,
  contactId: state.authentication.loginData.userDetails.IDNumber,
  customerName: state.authentication.loginData.userDetails.firstName + ' ' + state.authentication.loginData.userDetails.lastName,
  isShowPopUp: state.popupBenefitBlock.isShowPopup,
  isPrepared: state.popupBenefitBlock.isPrepared,
  popUpType: state.popupBenefitBlock.popUpBenefit.popUpType,
  progressType: state.popupBenefitBlock.popUpBenefit.progressTypeֳ
});

const mapDispatchToProps = {
  showAppLoader,
  hideAppLoader,
  updateContactAndAccountDetails,
  getContactAndAccountDetails,
  getCities,
  getStreets,
  validateHandler,
  changeHandler,
  setIsNotFoundError,
  setIsReported,
  setIsReadyForReport,
  setIsBenefitForm,
  clearAddress,
  initValidation,
  setHomeNum,
  resetBlock,
  setIsFromBack,
  setIsValid,
  reportAnalytics,
  clearAddressDetails,
  addressReportStep,
  handleCheckBox,
  updateUserDetails,
  reportCheckboxAgreeTermsCheckedWithBenefit,
  reportCheckboxAgreeTermsCheckedWithoutBenefit,
  reportPageLoadedWithBenefit,
  reportPageLoadedWithoutBenefit,
  reportWithBenefitSubmit,
  reportSuccess,
  reportFailed,
  reportWithoutBenefitSubmit,
  reportFailedBenefitIssue,
  setProgressType,
  setIsShowPopup,
  //benefit slice
  reportPopUpShow,
  reportPopUpAction,
  setIsPrepared,
  setPopUpType,
  resetBlockBenefit,
  setProgressTypeBenefit
};
export default connect(mapStateToProps, mapDispatchToProps)(UpdateContactAndAccountDetailsMain);